var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconToolScribbleThick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-tool-scribble-thick",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconS-tool-scribble-thick1",
    serifid: "iconS-tool-scribble-thick"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.749,18.451c0.66,-0.076 1.257,0.399 1.333,1.059c0.076,0.66 -0.398,1.258 -1.058,1.334c-0.847,0.097 -1.502,0.146 -2.084,0.155c-0.755,0.01 -1.393,-0.045 -2.159,-0.161c-1.524,-0.23 -3.479,-0.66 -4.648,-1.48c-0.919,-0.645 -1.44,-1.507 -1.398,-2.583c0.02,-0.518 0.198,-1.022 0.505,-1.492c0.307,-0.469 0.752,-0.91 1.239,-1.297c0.733,-0.584 2.654,-1.288 3.935,-2.698c0.528,-0.58 0.929,-1.305 0.981,-2.243c0.037,-0.679 -0.051,-1.293 -0.529,-1.817c-0.413,-0.452 -1.058,-0.831 -1.995,-1.183c-1.304,-0.489 -3.258,-0.984 -4.877,-0.376c-1.175,0.441 -2.079,1.536 -2.415,3.633c-0.094,0.587 -0.078,1.511 -0.264,2.364c-0.16,0.735 -0.46,1.417 -0.976,1.914c-0.669,0.645 -1.713,1.083 -3.439,0.772c-0.654,-0.118 -1.089,-0.744 -0.971,-1.398c0.118,-0.654 0.744,-1.09 1.398,-0.972c0.342,0.062 0.623,0.087 0.851,0.063c0.208,-0.021 0.37,-0.083 0.49,-0.199c0.297,-0.286 0.362,-0.733 0.409,-1.164c0.073,-0.659 0.054,-1.319 0.125,-1.761c0.521,-3.255 2.12,-4.821 3.945,-5.506c2.178,-0.819 4.815,-0.283 6.57,0.376c1.391,0.522 2.315,1.143 2.927,1.813c0.95,1.041 1.23,2.227 1.155,3.574c-0.086,1.555 -0.728,2.767 -1.603,3.73c-1.384,1.523 -3.425,2.332 -4.218,2.962c-0.279,0.222 -0.547,0.462 -0.722,0.731c-0.057,0.087 -0.111,0.171 -0.115,0.267c-0.006,0.147 0.062,0.261 0.162,0.359c0.152,0.151 0.366,0.269 0.595,0.383c0.935,0.465 2.216,0.692 3.242,0.847c0.627,0.094 1.148,0.143 1.765,0.134c0.515,-0.008 1.094,-0.053 1.844,-0.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolScribbleThick);
export default __webpack_public_path__ + "static/media/icon-tool-scribble-thick.aa4981981d4903310a4d8068014312c0.svg";
export { ForwardRef as ReactComponent };